import theme from '../theme';

export const getStatusColors = (status: string) => {
  let backgroundColor = '';
  let color = theme.colors.branco;

  switch (status) {
    case 'Em Processo':
    case 'Em Execução':
    case 'Vigente':
      backgroundColor = theme.colors.verde;
      break;
    case 'Em Elaboração':
    case 'Em elaboração':
      backgroundColor = theme.colors.laranja;
      break;
    case 'Finalizado':
    case 'Encerrado':
      backgroundColor = theme.colors.cinzaEscuro;
      break;
    case 'Suspenso':
      backgroundColor = theme.colors.laranja;
      break;
    case 'Cancelado':
      backgroundColor = theme.colors.vermelho;
      break;
    case 'Não Publicado':
      backgroundColor = theme.colors.amarelo;
      color = 'black';
      break;
  }

  return { backgroundColor, color };
};

export const getComponenteAfColor = (componenteAf: string) => {
  switch (componenteAf) {
    case 'Básico':
      return theme.colors.azulgov;
    case 'Especializado':
      return theme.colors.amarelogov;
    case 'Estratégico':
      return theme.colors.verdegov;
    case 'Oncológico':
      return theme.colors.padraoAzulClaro;
    default:
      return '';
  }
};

export const getTipoItemColor = (tipoItem: string) => {
  switch (tipoItem) {
    case 'D':
      return theme.colors.azul;
    case 'K':
      return theme.colors.laranja;
    default:
      return '';
  }
};
